import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';
import { OPEN_EXIT_DIALOG, CLOSE_EXIT_DIALOG } from 'actions/exitDialog';

const INITIAL_STATE = Immutable({
  isOpen: false,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case OPEN_EXIT_DIALOG:
      return state.merge({ isOpen: true });
    case CLOSE_EXIT_DIALOG:
      return INITIAL_STATE;
    default:
      return state;
  }
};
